import React, {useEffect} from "react";
import "./homePage.scss";
import "../../utils/Styles/globalclasses.scss";
import HeroSection from "./components/hero/HeroSection";
import HowItWorks from "./components/howItWorks/HowItWorks";
import TryToday from "./components/tryToday/TryToday";
import VirtualReceptionist from "./components/virtualReceptionist/VirtualReceptionist";
import Footer from "../../components/footer/Footer";
import Testimonial from "./components/testimonial/Testimonial";
// import TrustedCompanies from "./components/trustedCompanies/TrustedCompanies";
import TrustedCompanies from "../../components/trustedCompanies/TrustedCompanies";

const HomePage = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <div>
            <HeroSection/>
            <HowItWorks/>
            <TryToday/>
            <VirtualReceptionist/>
            <Testimonial/>
            <TrustedCompanies/>
            <Footer/>
        </div>
    );
};

export default HomePage;
